module.exports = __webpack_public_path__ + "static/media/Image-Intro.dbb096d5.png";